<template>
  <div>
    <section id="register-page">
      <div class="row justify-content-center">
        <div class="col-md-8 mt-5">
          <form @submit.prevent="getCaptcha" id="register-form">
            <div class="form-group m-label-left required">
              <input
                required
                type="text"
                class="form-control"
                id="register-first-name"
                :class="{
                  'is-invalid': $v.user.firstName.$error,
                  'is-valid': !$v.user.firstName.$invalid,
                }"
                v-model.trim.lazy="$v.user.firstName.$model"
              />
              <label for="register-first-name">First Name</label>
            </div>
            <div class="form-group m-label-left required">
              <input
                required
                type="text"
                class="form-control"
                id="register-last-name"
                :class="{
                  'is-invalid': $v.user.lastName.$error,
                  'is-valid': !$v.user.lastName.$invalid,
                }"
                v-model.trim.lazy="$v.user.lastName.$model"
              />
              <label for="register-last-name">Last Name</label>
            </div>

            <div class="row">
              <div class="form-group m-label col-md-4">
                <input
                  style="height: 48px !important"
                  type="text"
                  v-model="user.postal"
                  class="form-control"
                  id="postal-code"
                  @keyup="validate($event)"
                />
                <label for="postal-code">Postal Code</label>
              </div>

              <div class="form-group m-label filter-item col-md-8 required-right-city">
                <v-select
                  v-model="user.cityId"
                  label="name"
                  :options="[...getCitiesListByCountry]"
                  :reduce="city => city.id"
                  :clearable="false"
                  placeholder="City"
                  @change="validate($event)"
                  id="city"
                >
                  <template v-slot:no-options>
                    <div style="opacity: 0.5">You must choose country first</div>
                  </template>
                </v-select>
                <label for="city">City</label>
              </div>
            </div>
            <div class="form-group m-label-left filter-item required-right">
              <!-- <FloatLabel label="City"> -->
              <!--  @search="fetchOptionsForCountries" -->
              <v-select
                v-model="user.countryName"
                @input="fetchCitisByCountryId($event)"
                :options="[...getAllCountries]"
                label="name"
                placeholder="Country"
                :reduce="country => country"
                :clearable="false"
                required
              />
              <!-- </FloatLabel> -->
              <label for="country">Country</label>
            </div>
            <div class="form-group m-label-left required">
              <input
                type="email"
                class="form-control floating-field"
                id="register-email"
                :class="{
                  'is-invalid': $v.user.email.$error,
                  'is-valid': !$v.user.email.$invalid,
                }"
                v-model.trim.lazy="$v.user.email.$model"
                required
              />
              <label for="register-email">Email</label>
            </div>

            <div class="form-group m-label-left">
              <input
                :type="passwordType"
                id="register-password"
                class="form-control password-input"
                aria-label="Password"
                aria-describedby="passwordHelp"
                form="register-form"
                :class="{
                  'is-invalid': $v.user.password.$error,
                  'is-valid': !$v.user.password.$invalid,
                }"
                v-model.trim.lazy="$v.user.password.$model"
                required
              />
              <label for="register-password">Password</label>
              <span>
                <i
                  class="password-icon"
                  :class="[passwordIcon]"
                  @click="hidePassword = !hidePassword"
                ></i>
              </span>
            </div>

            <!-- <div class="form-group has-floating-label">
                <div class="input-group">
                  <float-label>
                    <input
                      :type="passwordTypeRepeat"
                      id="repeat-password"
                      class="form-control password-input"
                      placeholder="Confirm password"
                      aria-label="Password"
                      aria-describedby="confirmPasswordHelp"
                      form="register-form"
                      v-model="user.repeatPassword"
                      required
                    />
                  </float-label>
                  <span>
                    <i
                      class="fas password-icon"
                      :class="[passwordIconRepeat]"
                      @click="hideRepeatPassword = !hideRepeatPassword"
                    ></i>
                  </span> 
                </div>
            </div>-->
            <div class="agreement">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  v-model="user.isAgree"
                  class="custom-control-input"
                  id="customCheck1"
                />
                <label class="custom-control-label" for="customCheck1"
                  >I agree to
                  <router-link
                    target="_blank"
                    style="text-decoration: none"
                    :to="{ name: 'integrity' }"
                    >Jobshark's Integrity Policy and User Conditions</router-link
                  ></label
                >
              </div>
            </div>
            <div class="form-buttons text-center d-flex">
              <button
                type="submit"
                form="register-form"
                class="btn btn-secondary btn-custom w-50 mr-5"
              >
                {{ leftButton }}
              </button>

              <button type="button" @click="$emit('close')" class="btn btn-primary btn-custom w-50">
                {{ rightButton }}
              </button>
            </div>
          </form>

          <!--           <p class="separator mt-5">
            <span>OR</span>
          </p>

          <div class="social-buttons text-center mb-xs-0">
            <LinkedInButton @click="registerWithLinkedIn">Register with LinkedIn</LinkedInButton>
          </div> -->
          <!-- Error Messages -->
          <!--           <div v-if="$v.user.$error">
            <div
              v-if="!$v.user.password.required"
              class="alert alert-danger text-center"
              role="alert"
            >
              The password field is required.
            </div>
          </div>

          <div v-if="$v.user.$error">
            <div v-if="!$v.user.email.required" class="alert alert-danger text-center" role="alert">
              Please enter a valid email address.
            </div>
          </div>

          <div class="mt-2" v-if="!$v.user.password.minLength">
            <div class="alert alert-danger text-center" role="alert">
              Your password must be minimum 8 characters.
            </div>
          </div>

          <div v-if="$v.user.$error">
            <div
              v-if="!$v.user.firstName.required"
              class="alert alert-danger text-center"
              role="alert"
            >
              First Name is required.
            </div>
          </div>

          <div v-if="$v.user.$error">
            <div
              v-if="!$v.user.lastName.required"
              class="alert alert-danger text-center"
              role="alert"
            >
              Last Name is required.
            </div>
          </div> -->

          <!-- End Error Messages -->
          <div class="footer-small-link mt-4">
            <p class="text-center">
              <button
                style="background: none; border: none; color: #0088cc"
                id="already-have-account"
                @click="$emit('go-to-login', $event)"
              >
                Already have an account
              </button>
            </p>
          </div>
          <div class="footer-small-link mt-3">
            <p class="text-center">
              <button
                style="background: none; border: none; color: #0088cc"
                id="already-have-account"
                @click="$emit('open-employer-register', $event)"
              >
                I'm an employer and want to sign up
              </button>
            </p>
          </div>
          <!-- End .card -->
          <div class="footer-small-link text-center mt-4" v-if="haveTerms">
            <p>
              By creating an account, you agree to the
              <router-link :to="{ name: 'terms' }" target="_blank"
                >terms and conditions.</router-link
              >
            </p>
          </div>
        </div>
      </div>
      <Spinner :isLoading="isLoading" />
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { required, minLength, email } from 'vuelidate/lib/validators';
import { errorService } from '../../services/errorService';
import Spinner from '../common/LoadingSpinner/Spinner';
import axios from 'axios';

export default {
  components: {
    Spinner,
  },
  props: {
    haveTerms: {
      type: Boolean,
      default: false,
    },
    leftButton: {
      type: String,
      default: 'Sign Up',
    },
    rightButton: {
      type: String,
      default: 'Cancel',
    },
    id: String,
  },
  data: () => ({
    isLoading: false,
    myLocationOptions: [],
    hidePassword: true,
    hideRepeatPassword: true,
    isRegister: false,
    errorMessage: '',
    code: null,
    user: {
      firstName: '',
      lastName: '',
      selectedCountry: {},
      cityObj: {},
      email: '',
      password: '',
      uncompleted_job_id: null,
      countryId: '',
      postal: '',
      city: '',
      cityId: '',
      countryName: '',
      isAgree: false,
      reToken: '',
      campaign_id: null,
      campaign_medium: null,
      campaign_name: null,
      campaign_source: null,
    },
  }),
  validations: {
    user: {
      firstName: {
        required,
        minLength: minLength(3),
      },
      lastName: {
        required,
        minLength: minLength(3),
      },
      email: {
        required,
        email,
      },
      password: {
        required,
        minLength: minLength(8),
      },
    },
  },
  watch: {
    user: {
      handler() {
        this.errorMessage = '';
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(['retrieveCitiesListByCountryId', 'searchLocationByName']),
    registerWithLinkedIn() {
      this.$store.dispatch('LinkedInProvider', { jobId: '', from: 'register' });
    },
    /* fetchCitiesByCountryId(e) {
      this.selectedCountry = e;
      // this.countryId = e.id;
      this.retrieveCitiesListByCountryId({ id: this.selectedCountry.id });
    }, */
    getCaptcha() {
      let vm = this;
      const SIGNIN = () => this.onRegister();
      grecaptcha
        .execute('6LdyDhspAAAAAJWVsgRkufJ8fAJBeSDpWDPUsvAn', { action: 'submit' })
        .then(function(token) {
          vm.user.reToken = token;
          SIGNIN();
        });
    },
    fetchOptions(search, loading) {
      if (search.length < 3) {
        // this.myLocationOptions = [];
      }

      if (search.length >= 3) {
        loading(true);

        this.searchLocationByName(search)
          .then(response => {
            const citiesList = response.data.cities;
            const countriesList = response.data.countries;
            const concatedLists = [].concat(countriesList, citiesList);
            this.myLocationOptions = concatedLists;
            loading(false);
          })
          .catch(err => {
            loading(false);
            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 8000,
            });
          });
      }
    },
    onRegister() {
      if (
        this.user.firstName === '' ||
        this.user.lastName === '' ||
        this.user.email === '' ||
        this.user.cityId === '' ||
        this.user.countryName === '' ||
        this.user.password === ''
      ) {
        this.$toasted.error(`Please enter all mandatory fields`, {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
        return false;
      }
      if (!this.user.isAgree) {
        this.$toasted.error(
          `Please agree to Jobshark's Integrity Policy and User Conditions to register`,
          {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          },
        );
        return false;
      }
      this.$emit('set-email', this.user);
      this.isLoading = true;
      const {
        firstName,
        lastName,
        email,
        password,
        uncompleted_job_id,
        countryId,
        cityId,
        postal,
        isAgree,
        reToken,
        campaign_id,
        campaign_medium,
        campaign_name,
        campaign_source,
      } = this.user;

      this.isRegister = true;

      this.$store
        .dispatch('registerUserId', {
          firstName,
          lastName,
          country_id: countryId,
          city_id: cityId,
          postal,
          uncompleted_job_id,
          email,
          password,
          isAgree,
          reToken,
          campaign_id,
          campaign_medium,
          campaign_name,
          campaign_source,
        })
        .then(response => {
          const { id } = response.data;

          if (id) {
            this.isLoading = false;
            this.$emit('emailVerification');
          }
        })
        .catch(err => {
          this.isRegister = false;
          this.isLoading = false;

          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-unlock-alt',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
    /* validUser() {
      const { email, password } = this.user;

      const isEmpty = email || password;

      const invalidPasswordLength = password.length < 6;

      if (!isEmpty) {
        this.errorMessage = 'The field password and email cannot be empty!';
        return false;
      }

      if (invalidPasswordLength) {
        this.errorMessage = 'Password should be at least six characters';
        return false;
      }

      if (this.user.password.length < 6) {
        this.errorMessage = 'The password must be at least six characters';
        return false;
      }

      return true;
    }, */
    getDefaultCountry() {
      const sweden = this.getAllCountries.find(country => country.name === 'Sweden');
      axios
        .get(`${process.env.VUE_APP_API_URL}/common/address/getaddressbyip`, {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(({ data }) => {
          if (!data.country_name) {
            this.user.countryName = sweden.name;
            this.user.countryId = sweden.id;
            this.retrieveCitiesListByCountryId({ id: sweden.id });
          } else {
            this.user.countryName = data.country_name;
            this.user.countryId = data.country_id;
            this.user.city = data.city_name;
            this.user.cityId = data.city_id;
            this.retrieveCitiesListByCountryId({ id: data.country_id });
          }
        });
    },
    getCampainParams() {
      if (this.$route.query.utm_id) {
        this.user.campaign_id = this.$route.query.utm_id;
      }
      if (this.$route.query.utm_medium) {
        this.user.campaign_medium = this.$route.query.utm_medium;
      }
      if (this.$route.query.utm_campaign) {
        this.user.campaign_name = this.$route.query.utm_campaign;
      }
      if (this.$route.query.utm_source) {
        this.user.campaign_source = this.$route.query.utm_source;
      }
    },
    fetchCitisByCountryId(e) {
      this.user.cityId = '';
      this.user.countryName = e.name;
      this.user.countryId = e.id;
      this.retrieveCitiesListByCountryId({ id: this.user.countryId });
    },
  },
  computed: {
    passwordType() {
      return this.hidePassword ? 'password' : 'text';
    },
    passwordIcon() {
      return this.hidePassword ? 'far fa-eye-slash' : 'far fa-eye';
    },
    ...mapGetters(['getAllCountries', 'getCitiesListByCountry']),
  },
  mounted() {
    this.user.uncompleted_job_id = this.id;
    this.getDefaultCountry();
    this.getCampainParams();
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.form-group.required {
  position: relative;

  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 12px;
    right: 12px;
    color: red;
    opacity: 0.6;
  }
}

.form-group.required-right {
  position: relative;

  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 10px;
    color: red;
    opacity: 0.6;
  }
}

.form-group.required-right-city {
  position: relative;

  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 25px;
    color: red;
    opacity: 0.6;
  }
}

.form-group.required-fixed-right {
  position: relative;

  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 6px;
    color: red;
    opacity: 0.6;
  }
}

.form-group.required-fixed-drop {
  position: relative;

  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 25px;
    color: red;
    opacity: 0.6;
  }
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.form-control {
  padding-left: 18px;
}
</style>
